import {
  format,
  formatDistance,
  startOfDay,
  endOfDay,
  parseISO,
  isValid,
  isFuture,
  addSeconds,
} from "date-fns";

export const standardDateFormats = {
  DATE: "dd/MM/yyyy",
  DATE_TIME: "dd/MM/yyyy HH:mm",
  FULL_DATE_TIME: "PPPP h:mmaaaaa'm'",
  DATE_WITH_DAYE_OF_WEEK_NAME: "cccc dd/MM/yyyy",
  TIME: "HH:mm",
};

const convertUtcStringToLocal = (dateStr: string) => {
  const parsedDate = new Date(dateStr);
  return new Date(
    Date.UTC(
      parsedDate.getFullYear(),
      parsedDate.getMonth(),
      parsedDate.getDate(),
      parsedDate.getHours(),
      parsedDate.getMinutes(),
      parsedDate.getSeconds(),
      parsedDate.getMilliseconds()
    )
  );
};

export const isIsoDateString = (testDate: any) => {
  const regex = "[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}";
  var asString = String(testDate);
  var found = asString.match(regex.toString());
  if (found) {
    return true;
  }
  return false;
};

//BRN I got rid of this in 2nd July 2021 it just checks if a number...
//export const isIsoDateString = (arg: string | null) =>
//  !!arg && isValid(parseISO(arg));
//

export const startOfDayUtc = (utcIsoString: string | null | undefined) => {
  var startDate = utcIsoString && startOfDay(Date.parse(utcIsoString));
  return (
    startDate &&
    new Date(
      startDate.getTime() - startDate.getTimezoneOffset() * 60000
    ).toISOString()
  );
};

export const endOfDayUtc = (utcIsoString: string | null | undefined) =>
  utcIsoString &&
  addSeconds(endOfDay(Date.parse(utcIsoString)), -1).toISOString();

export const distanceAgo = (utcIsoString: string | null | undefined) =>
  utcIsoString &&
  formatDistance(convertUtcStringToLocal(utcIsoString), Date.now(), {
    addSuffix: true,
  });

export const formatUtcDate = (
  utcIsoString: string | null | undefined,
  formatDefinition: string
) =>
  utcIsoString &&
  format(convertUtcStringToLocal(utcIsoString), formatDefinition);

export const formatAsTodayYesterdayOrDate = (
  utcIsoString: string | null | undefined
) => {
  if (!utcIsoString) {
    return utcIsoString;
  }

  const itemDate = formatUtcDate(utcIsoString, standardDateFormats.DATE)!;
  const today = formatUtcDate(
    new Date().toISOString(),
    standardDateFormats.DATE
  );
  const yesterday = formatUtcDate(
    new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    standardDateFormats.DATE
  );

  if (itemDate === today) {
    return "Today";
  }

  if (itemDate === yesterday) {
    return `Yesterday ${itemDate}`;
  }

  if (isFuture(new Date(utcIsoString))) {
    return "Upcoming";
  }

  return formatUtcDate(
    utcIsoString,
    standardDateFormats.DATE_WITH_DAYE_OF_WEEK_NAME
  );
};

export const isFutureDate = (utcIsoString: string | null | undefined) =>
  utcIsoString && isFuture(new Date(utcIsoString));
